/**
 * Created by Ning Jiang on 3/20/2017.
 */

import {IBonusBunniesGameData, IBonusBunniesInitData} from "./data/IBonusBunniesGameData";
import {IBonusSymbolQueue} from "./data/IBonusSymbolQueue";
import {BonusBunniesGameMode} from "../gamemode/BonusBunniesGameMode";
import {SpinServerDataParser} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinServerDataParser";
import {BonusBunniesGameModuleConfig} from "../BonusBunniesGameModuleConfig";
import {BonusBunniesParsedGameData} from "./data/BonusBunniesParsedGameData";

export class BonusBunniesServerDataParser extends SpinServerDataParser {

    constructor() {
        super();
    }

    public parseBonusSymbolQueueData(rawData:IBonusBunniesGameData):IBonusSymbolQueue[] {
        let bonusSymbolQueue:IBonusSymbolQueue[] = [];
        for(let bonusSymbolWinData of rawData.bonusSymbolQueue!) {
            bonusSymbolQueue.push({
                reelPos : bonusSymbolWinData.reelPos,
                rowPos : bonusSymbolWinData.rowPos,
                startMultiplier : bonusSymbolWinData.startMultiplier,
                symbol : bonusSymbolWinData.symbol
            });
        }
        return bonusSymbolQueue;
    }

    public parseFastNearWinData(rawData:IBonusBunniesGameData | IBonusBunniesInitData):boolean[] {
        const nearWinReels:boolean[] = [];
        for(let i:number = 0; i < 4; i++) {
            nearWinReels.push(false);
        }
        if(rawData.mode == BonusBunniesGameMode.NORMAL && rawData.wasFeatureBuy == false) {
            let reels:number = 3;
            for(let i:number = 0; i < 3; i++) {
                for(let j:number = 1; j < 5; j++) {
                    if(rawData.reels[i][j] == "B") {
                        while(reels >= (i + 1)) {
                            nearWinReels[reels] = true;
                            reels--;
                        }
                        break;
                    }
                    if(rawData.reels[i][j] == "W") {
                        while(reels >= (i + 1)) {
                            nearWinReels[reels] = true;
                            reels--;
                        }
                        break;
                    }
                }
            }
        }
        return nearWinReels;
    }

    public parseNearWinData(rawData:IBonusBunniesGameData | IBonusBunniesInitData):boolean[] {
        const nearWinReels:boolean[] = [];
        let numberOfReels:number;
        if(rawData.mode == BonusBunniesGameMode.BONUS_GAME) {
            numberOfReels = 25;
        } else {
            numberOfReels = 4;
        }
        for(let i:number = 0; i < numberOfReels; i++) {
            nearWinReels.push(false);
        }
        //Near win in base game for Wild and Bunnie sym
        if(rawData.mode == BonusBunniesGameMode.NORMAL && rawData.wasFeatureBuy == false) {
            let reels:number = 3;
            let symbolBCounter:number = 0;
            let symbolWCounter:number = 0;
            for(let i:number = 0; i < 3; i++) {
                for(let j:number = 1; j < 5; j++) {
                    if(rawData.reels[i][j] == "B") {
                        symbolBCounter++;
                        if(symbolBCounter > 1 || (symbolBCounter > 0 && symbolWCounter > 0)) {
                            while(reels >= (i + 1)) {
                                nearWinReels[reels] = true;
                                reels--;
                            }
                            break;
                        }
                    }
                    if(rawData.reels[i][j] == "W") {
                        symbolWCounter++
                        if(symbolWCounter > 1 || (symbolBCounter > 0 && symbolWCounter > 0)) {
                            while(reels >= (i + 1)) {
                                nearWinReels[reels] = true;
                                reels--;
                            }
                            break;
                        }
                    }
                }
            }
        }

        const lastBonusSymbolPositionExcitement:number[] = (<IBonusBunniesGameData>rawData).lastBonusSymbolPositionExcitement;
        if(lastBonusSymbolPositionExcitement[0] > -1) {
            nearWinReels[(lastBonusSymbolPositionExcitement[0] * 5) + lastBonusSymbolPositionExcitement[1]] = true;
        }

        return nearWinReels;
    }

    public parseOriginalReelData(rawData:IBonusBunniesGameData | IBonusBunniesInitData):string[][] {
        let parsedReels:string[][] = [];
        for(let i:number = 0; i < rawData.reels.length; i++) {
            parsedReels.push(rawData.reels[i]);
        }
        return parsedReels;
    }

    //Making sure we only get maximum 2 Settlers
    public parseB4bonusOverlaySymbolsInitData(rawData:IBonusBunniesInitData):string[][] {
        if(rawData.mode == BonusBunniesGameMode.BONUS_GAME && rawData.isRestoreState == true) {
            let b4Counter:number = 0;
            for(let i:number = 0; i < rawData.bonusOverlaySymbols.length; i++) {
                for(let j:number = 0; j < rawData.bonusOverlaySymbols[i].length; j++) {
                    if(rawData.bonusOverlaySymbols[i][j] == "B4") {
                        b4Counter++;
                        if(b4Counter > 2) {
                            rawData.bonusOverlaySymbols[i][j] = "B";
                        }
                    }
                }
            }
        }
        return rawData.bonusOverlaySymbols;
    }

    //Making sure we only get maximum 2 Settlers
    public parseB4ReelData(rawData:IBonusBunniesGameData):string[][] {
        if(rawData.mode == BonusBunniesGameMode.BONUS_GAME) {
            if((BonusBunniesGameModuleConfig.bonusBunniesBottomRowWPController.bottomRowActivationPlayed == true
                && BonusBunniesGameModuleConfig.bonusBunniesExtraReelWPController.lastReelActivationPlayed == false)
                || (BonusBunniesGameModuleConfig.bonusBunniesBottomRowWPController.bottomRowActivationPlayed == false
                    && BonusBunniesGameModuleConfig.bonusBunniesExtraReelWPController.lastReelActivationPlayed == true)) {
                //We have one B4. Let's make sure we don't get two more.
                let b4Counter:number = 0;
                for(let i:number = 0; i < rawData.reels.length; i++) {
                    for(let j:number = 0; j < rawData.reels[i].length; j++) {
                        if(rawData.reels[i][j] == "B4" && j > 0) {
                            //Making sure the B4 is on an active reel
                            if(rawData.bonusNewPositions[i][j - 1] == true) {
                                b4Counter++;
                                if(b4Counter > 1) {
                                    rawData.reels[i][j] = "B";
                                }
                            }
                        }
                    }
                }
            }
        }
        return rawData.reels;
    }

    public parseReelData(rawData:IBonusBunniesGameData | IBonusBunniesInitData):string[][] {
        let parsedReels:string[][] = [];
        if((rawData.mode == BonusBunniesGameMode.NORMAL && rawData.nextMode == BonusBunniesGameMode.BONUS_GAME) || (rawData.mode == BonusBunniesGameMode.BONUS_GAME && rawData.nextMode == BonusBunniesGameMode.BONUS_GAME)) {
            if((<BonusBunniesParsedGameData><unknown>rawData).lastBonusSymbolPositionExcitement && (<BonusBunniesParsedGameData><unknown>rawData).lastBonusSymbolPositionExcitement[0] < 0) {
                rawData.reelsNextSpin = "BONUS_REELSET";
            }
        }

        //Creates 20 fake reels since the server only sends 5
        if(rawData.mode == BonusBunniesGameMode.BONUS_GAME) {
            for(let i:number = 0; i < rawData.reels.length; i++) {
                for(let j:number = 1; j < 6; j++) {
                    let fakeReel:string[] = ["X", "X", "X", "X", "X", "X", "X"];
                    fakeReel[1] = rawData.reels[i][j];
                    parsedReels.push(fakeReel);
                }
            }
        } else {
            for(let i:number = 0; i < rawData.reels.length; i++) {
                parsedReels.push(rawData.reels[i]);
            }
            //Adding dummy reels to server response (need to be 25 reels)
            for(let i:number = 0; i < 20; i++) {
                parsedReels.push(["L4", "M1", "L2", "L5", "M2", "M3", "L2"]);
            }
        }

        //If restore into Bonus Game intro we need to set Base Game reels correct
        if((<IBonusBunniesInitData>rawData).isRestoreState == true && rawData.mode == BonusBunniesGameMode.NORMAL && rawData.nextMode == BonusBunniesGameMode.BONUS_GAME) {
            const reelsEnteringBonus:string[][] = (<IBonusBunniesInitData>rawData).reelsEnteringBonus;
            let isSpreadingWild:boolean = false;
            for(let i:number = 0; i < reelsEnteringBonus.length; i++) {
                for(let j:number = 1; j < reelsEnteringBonus[i].length; j++) {
                    //If Wild expand B should be set to BEmpty
                    if(reelsEnteringBonus[i][j] == "BW") {
                        parsedReels[i][j] = "BEmpty";
                    }
                    if(reelsEnteringBonus[i][j] == "W") {
                        parsedReels[i][j] = "WExpand";
                    }
                }
            }
        }

        return parsedReels;
    }
}